import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'components/Dropdown2';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import { TIME_OPTIONS } from './AddMenuFlyout.helpers';
import messages from './AddMenuFlyout.messages';

const { element } = bem('add-menu-modal');

const TIME_FORMAT = { hour: 'numeric', minute: '2-digit' };
const getTimeOption = value => TIME_OPTIONS.find(option => option.value === value);

const TimeDropdown = ({ className, disabled, label, onChange, prefixLabel, value }) => {
  const intl = useIntl();
  const selectedOption = getTimeOption(value);
  const formatTime = option => intl.formatTime(option.date, TIME_FORMAT);

  return (
    <Dropdown
      attachment="left"
      className={className}
      dataCypress={`add-menu-time-${label}`}
      disabled={disabled}
      options={TIME_OPTIONS}
      selectedOption={selectedOption}>
      {[
        <DropdownToggle key={`${label}-toggle`} className={element('time-toggle')}>
          {prefixLabel && <span className={element('time-prefix')}>{prefixLabel}</span>}
          {selectedOption ? formatTime(selectedOption) : <Message message={messages.selectTimePlaceholder} />}
        </DropdownToggle>,
        <DropdownMenu key={`${label}-menu`} className={element('time-menu')}>
          {TIME_OPTIONS.map(option => (
            <DropdownItem
              key={`${label}-${option.value}`}
              isSelected={option.value === value}
              onClick={() => onChange(option.value)}>
              {formatTime(option)}
            </DropdownItem>
          ))}
        </DropdownMenu>,
      ]}
    </Dropdown>
  );
};

TimeDropdown.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  prefixLabel: PropTypes.string,
  value: PropTypes.string.isRequired,
};

TimeDropdown.defaultProps = {
  className: '',
  disabled: false,
  prefixLabel: '',
};

export default TimeDropdown;
